<template>
  <main id="app">
    <!-- <Header :hasNav="hasHeaderNav" v-show="hasHeader"/> -->
    <Header v-show="hasHeader" :isSticky="headerIsSticky" />
    <router-view />

    <!-- 企业微信弹窗 2024-12-09 -->
    <EnterpriseWeChat />

    <Footer v-show="hasFooter"/>
  </main>
</template>

<script>
import Header from "@components/header";
import Footer from "@components/footer";
import EnterpriseWeChat from "@components/EnterpriseWeChat";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    EnterpriseWeChat,//企业微信弹窗
  },
  data() {
    return {
      hasHeader: true, // 是否显示header
      headerIsSticky: false,
      // hasHeaderNav: false, // 是否显示header的导航
      hasFooter: true, // 是否显示footer
    };
  },
  beforeCreate() {
    // 读取缓存的userInfo
    const userInfo = this.getUserInfo();
    userInfo && this.updateUserInfo(userInfo);
  },
  created() {
    // 路由守卫

    this.$router.beforeResolve((to, from, next) => {
      this.test();
      const defaultMeta = {
        hasHeader: true,
        headerIsSticky: false,
        // hasHeaderNav: false,
        hasFooter: true,
      };
      const meta = { ...defaultMeta, ...to.meta };
      Object.keys(meta).forEach((v) => {
        this[v] = meta[v];
      });

      // 检测用户
      const { disableCheckUser } = to.meta;
      if (disableCheckUser === undefined) {
        const userInfo = this.getUserInfo();
        // console.log("路由守卫");
        if (userInfo === null || "token" in userInfo === false) {
          // 留存要去的页面及参数
          const { name, query, params, path } = to;
          const data = { name, query, params, path };
          next({ name: "login", params: data });
          return;
        }
      }
      next();
    });
  },
};
</script>

<style>
#app {
  /* min-width: 1200px; */
}


@media only screen and (max-width: 3840px) {
  #app>main {
    width: 1200px;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 1024px) {
  #app>main {
    width: 768px;
    padding: 0 2%;
  }
}

@media only screen and (max-width: 768px) {
  #app>main {
    width: 100%;
  }
}
</style>
